module.exports = __webpack_public_path__ + "img/btn_menu_province.c7952df2.png";